import React, { useEffect } from 'react';
import { Grid, Typography, FormControl, RadioGroup as MuiRadioGroup, FormControlLabel, Radio, FormHelperText } from '@mui/material';
import { makeStyles } from '@mui/styles';
import './styles.scss';

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: '100%',
    marginTop: theme.spacing(1.5),
  },
  title: {
    fontSize: theme.spacing(1.5),

  },
  label: {
    padding: '8px',
    lineHeight: '40px',
    fontSize: '14px',
    [theme.breakpoints.up('lg')]: {
      padding: 0,
    },
    '& .MuiTypography-body1': {
      fontSize: '14px',
      fontFamily: 'cernMedium',
      marginLeft: 0,
      marginRight: '30px',
    },
  },
}));

export default function InlineRadioGroup(props) {
  const {
    name, label, value, onChange, error = null, items, row, inputRef, required,
  } = props;
  const classes = useStyles();
  const [initialValue, setInitialValue] = React.useState(value);

  const handleChange = (e) => {
    setInitialValue(e.target.value);
    return e;
  };

  useEffect(() => {
    setInitialValue(value);
  }, [value]);

  return (
    <FormControl className={classes.formControl}>
      <Grid container spacing={0}>
        { label &&
          <Grid item xs={12} md={2} >
            <Typography
              component="p"
              className={`${required ? 'inputLabel required' : 'inputLabel'} ${classes.label}`}
            >{label}
            </Typography>
          </Grid>
        }
        <Grid item xs={12} md={label ? 8 : 12} >
          <MuiRadioGroup
            row={row || true}
            name={name}
            value={initialValue}
            onChange={e => onChange(handleChange(e))}
            ref={inputRef}
          >
            {
                items?.map(item => (
                  item.visible && <FormControlLabel
                    key={item?.id}
                    value={item?.id}
                    control={<Radio />}
                    label={item?.title}
                    className={classes.label}
                  />
                ))
            }
          </MuiRadioGroup>
          {error && <FormHelperText className="MuiFormHelperText-contained Mui-error MuiFormHelperText-marginDense">{error}</FormHelperText>}
        </Grid>
      </Grid>
    </FormControl>
  );
}
